module.exports = __webpack_public_path__ + "static/money2-76015a4b46a0b2946c0af5aeea940252.png";